<script>
// import axios from "axios";
// import Swal from "sweetalert2";

export default {
  props: {
    show: Boolean,
    data: Object,
    mode: {
      type: String,
      default: "add",
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  watch: {
    modalShow(val) {
      if (val) {
        if (this.mode === "edit" && this.data) {
          this.form = { ...this.data };
        } else {
          this.resetForm();
        }
      } else {
        this.resetForm();
      }
    },
  },

  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      form: {
        id_nama: null,
        id_jabatan: null,
        id_validator_pengganti: null,
        alasan: "",
        id_user_upload: null,
      },

      optionsNama: [
        {value: '', text:'Pilih Nama'},
        {value: 1, text: 'Bagas'},
        {value: 2, text: 'Bambang'},
        {value: 3, text: 'Ahmad'},
      ],

      optionsJabatan: [
        {value: '', text:'Pilih Jabatan'},
        {value: 1, text: 'Jabatan 1'},
        {value: 2, text: 'Jabatan 2'},
        {value: 3, text: 'Jabatan 3'},
      ],

      optionsValidator: [
        {value: '', text:'Pilih Validator'},
        {value: 1, text: 'Nama Sample A'},
        {value: 2, text: 'Nama Sample B'},
        {value: 3, text: 'Nama Sample C'},
      ],

      optionsUserUploads: [
        {value: '', text:'Pilih User Upload'},
        {value: 1, text: 'User Sample A'},
        {value: 2, text: 'User Sample B'},
        {value: 3, text: 'User Sample C'},
      ]
    };
  },

  methods: {
    resetForm() {
      this.form = {
        id_nama: null,
        id_jabatan: null,
        id_validator_pengganti: null,
        alasan: "",
        id_user_upload: null,
      };
    },
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    title="Tambah / Edit Validator"
    size="md"
    hide-footer
  >
    <b-form @submit.prevent="store">
      <b-form-group 
        label="Nama" 
        label-for="select-nama"
        class="fw-medium"
      >
        <b-form-select
          id="select-nama"
          v-model="form.id_nama"
        >
          <option v-for="opt in optionsNama" :key="opt.value" :value="opt.value">
            {{ opt.text }}
          </option>
        </b-form-select>
      </b-form-group>

      <b-form-group 
        label="Jabatan" 
        label-for="select-jabatan"
        class="fw-medium"
      >
        <b-form-select
          id="select-jabatan"
          v-model="form.id_jabatan"
        >
          <option v-for="opt in optionsJabatan" :key="opt.value" :value="opt.value">
            {{ opt.text }}
          </option>
        </b-form-select>
      </b-form-group>

      <b-form-group 
        label="Validator" 
        label-for="select-validator"
        class="fw-medium"
      >
        <b-form-select
          id="select-validator"
          v-model="form.id_validator_pengganti"
        >
          <option v-for="opt in optionsValidator" :key="opt.value" :value="opt.value">
            {{ opt.text }}
          </option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        label="Alasan"
        label-for="select-validator"
        class="fw-medium"
      >
        <b-form-textarea 
          v-model="form.alasan"
          style="resize:none;"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group 
        label="User Upload" 
        label-for="select-userupload"
        class="fw-medium"
      >
        <b-form-select
          id="select-userupload"
          v-model="form.id_user_upload"
        >
          <option v-for="opt in optionsUserUploads" :key="opt.value" :value="opt.value">
            {{ opt.text }}
          </option>
        </b-form-select>
      </b-form-group>

      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary"> Simpan </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
